/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedAddressRequest
 */
export interface APIPatchedAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof APIPatchedAddressRequest
     */
    address1?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedAddressRequest
     */
    address2?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedAddressRequest
     */
    address3?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedAddressRequest
     */
    zipCode?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedAddressRequest
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedAddressRequest
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedAddressRequest
     */
    info?: string;
}

/**
 * Check if a given object implements the APIPatchedAddressRequest interface.
 */
export function instanceOfAPIPatchedAddressRequest(value: object): value is APIPatchedAddressRequest {
    return true;
}

export function APIPatchedAddressRequestFromJSON(json: any): APIPatchedAddressRequest {
    return APIPatchedAddressRequestFromJSONTyped(json, false);
}

export function APIPatchedAddressRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedAddressRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'address1': json['address_1'] == null ? undefined : json['address_1'],
        'address2': json['address_2'] == null ? undefined : json['address_2'],
        'address3': json['address_3'] == null ? undefined : json['address_3'],
        'zipCode': json['zip_code'] == null ? undefined : json['zip_code'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
        'info': json['info'] == null ? undefined : json['info'],
    };
}

export function APIPatchedAddressRequestToJSON(value?: APIPatchedAddressRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'address_1': value['address1'],
        'address_2': value['address2'],
        'address_3': value['address3'],
        'zip_code': value['zipCode'],
        'city': value['city'],
        'country': value['country'],
        'info': value['info'],
    };
}

